import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Steps } from "antd";

import { withRedux } from "../hoc";

const Step = Steps.Step;

const mapStateToProps = (state) => {
  return {
    t: _.get(state, "t"),
    language: _.get(state, "language"),
  };
};

@withRedux(mapStateToProps)
export default class index extends Component {
  static propTypes = {
    currentSteps: PropTypes.number,
    allSteps: PropTypes.arrayOf(PropTypes.shape()),
  };
  static defaultProps = {
    currentSteps: 0,
    allSteps: [
      { id: 1, name: "Date & Showtime" },
      { id: 2, name: "Select your seats" },
      { id: 3, name: "Payment" },
      { id: 4, name: "Confirmation" },
    ],
  };
  render() {
    const { allSteps, currentSteps, t } = this.props;
    return (
      <div className="steps-component">
        <Steps size="small" current={currentSteps}>
          {_.map(allSteps, (item) => {
            return (
              <Step key={_.get(item, "id")} title={t(_.get(item, "name"))} />
            );
          })}
        </Steps>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Steps.js